import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftSidePanelProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearLeftSidePanel(props: RearLeftSidePanelProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Left Side Panel"
      width={864}
      height={106}
      viewBox="0 0 864 106"
      position={{right: 54, bottom: 0}}
    >
      <path
        d="M169 12.8764C105 26.8666 29.9801 55.7104 1 59.8448V59.9977C2.26434 62.831 7.24392 69.02 18 70.9982V71C39 64 162.033 28 218 24C242.055 22.2807 266.035 20.268 283 20L313 20H332H376C405 20 472.063 24.4791 512 36C557.063 48.9999 596 57.8893 596 76C596 94 563 105 536 105L684 105C706 104 747 90.9993 770 80.9988C784.95 74.4984 802.083 65.636 810 63.9979C837.013 58.4088 845.633 47.0239 852 34.9964C854.101 31.0276 857.259 25.9369 861 18.9956C829.751 32.3041 757 32.9963 717 32.9963C651 30.9962 601 24.9959 588 12.9953C476 -2.00551 282.993 -1.21489 208 5.9949C196.068 7.142 182.784 9.92333 169 12.8764Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M684 105C706 104 747 90.9993 770 80.9988C784.95 74.4984 802.083 65.636 810 63.9979C837.013 58.4088 845.633 47.0239 852 34.9964C854.101 31.0276 857.259 25.9369 861 18.9956C829.751 32.3041 757 32.9963 717 32.9963C651 30.9962 601 24.9959 588 12.9953C476 -2.00551 282.993 -1.21489 208 5.9949C196.068 7.142 182.784 9.92333 169 12.8764C105 26.8666 29.9801 55.7104 1 59.8448V59.9977C2.26434 62.831 7.24392 69.02 18 70.9982V71C39 64 162.033 28 218 24C242.055 22.2807 266.035 20.268 283 20L313 20H332H376C405 20 472.063 24.4791 512 36C557.063 48.9999 596 57.8893 596 76C596 94 563 105 536 105C603.561 105 616.439 105 684 105ZM684 105L686 105"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M595 81.3044C688.031 79.8281 762 77.1304 783 75.0435"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
